<template>
  <div>
    <b-row>
      <b-col md="12" class="hide-label">
        <InputTextArea
          class="mb-4"
          type="text"
          textFloat="Text"
          placeholder=""
          name="text"
          rows="5"
          isRequired
          v-model="response.content.Text.Text"
          :isValidate="v.content.Text.Text.$error"
          :v="v.content.Text.Text"
          :textOption="response.content.Text"
        />
      </b-col>
      <b-col md="12">
        <span class="text-main-color f-size-16 font-weight-bold">Image</span>
      </b-col>
      <b-col md="12">
        <ImageUpload
          class="mt-1"
          v-bind:dataFile="response.content.Image"
          :v="v.content.Image.ImageUrl"
          @handleChangeImage="handleChangeImage"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import InputTextArea from "@/components/inputs/InputTextArea";
import ImageUpload from "@/views/pages/flow-builder/components/sidebar/ImageUpload";
export default {
  components: {
    ImageUpload,
    InputTextArea,
  },
  props: {
    response: {
      required: true,
      type: Object,
    },
    v: {
      required: false,
      type: Object,
    },
  },
  methods: {
    handleChangeImage(image) {
      this.response.content.Image.ImageUrl = image;
    },
  },
};
</script>

<style lang="scss" scoped></style>
